import React from 'react';
import { Box, Typography, Card, CardContent, Rating, Avatar } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';
import FormatQuoteIcon from '@mui/icons-material/FormatQuote';
import { useTranslation } from 'react-i18next'; // 1. Import hook

// Import Swiper React components
import { Swiper, SwiperSlide } from 'swiper/react';
import { Pagination, Autoplay } from 'swiper/modules';

import Img1 from '../assets/images/img1041.png'; 

// Import Swiper styles
import 'swiper/css';
import 'swiper/css/pagination';

// --- Static Data for Testimonials using translation KEYS ---
const testimonialsData = [
  { quoteKey: "testimonial_1_quote", nameKey: "testimonial_1_name", originKey: "testimonial_1_origin", rating: 5 },
  { quoteKey: "testimonial_2_quote", nameKey: "testimonial_2_name", originKey: "testimonial_2_origin", rating: 5 },
  { quoteKey: "testimonial_3_quote", nameKey: "testimonial_3_name", originKey: "testimonial_3_origin", rating: 5 },
  { quoteKey: "testimonial_4_quote", nameKey: "testimonial_4_name", originKey: "testimonial_4_origin", rating: 5 },
  { quoteKey: "testimonial_5_quote", nameKey: "testimonial_5_name", originKey: "testimonial_5_origin", rating: 5 },
  { quoteKey: "testimonial_6_quote", nameKey: "testimonial_6_name", originKey: "testimonial_6_origin", rating: 5 },
  { quoteKey: "testimonial_7_quote", nameKey: "testimonial_7_name", originKey: "testimonial_7_origin", rating: 4 },
  { quoteKey: "testimonial_8_quote", nameKey: "testimonial_8_name", originKey: "testimonial_8_origin", rating: 5 },
  { quoteKey: "testimonial_9_quote", nameKey: "testimonial_9_name", originKey: "testimonial_9_origin", rating: 4 },
];

// --- The Main Component ---
const Testimonials = () => {
  const { t } = useTranslation(); // 2. Initialize translation function
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const isTablet = useMediaQuery(theme.breakpoints.between('sm', 'md'));

  const slidesPerView = isMobile ? 1 : isTablet ? 2 : 3;

  return (
    <Box
      sx={{
        py: { xs: 6, md: 10 },
        px: { xs: 2, md: 4 },
        position: 'relative',
        background: `url(${Img1})`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        '&::before': {
          content: '""',
          position: 'absolute',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundColor: 'rgba(245, 240, 234, 0.6)',
          zIndex: 1,
        },
        '& > *': {
          position: 'relative',
          zIndex: 2,
        },
      }}
    >
      <Box sx={{ textAlign: 'center', mb: 6 }}>
        <Typography
          variant="h2"
          component="h2"
          sx={{
            fontWeight: 'bold',
            fontFamily: "'Playfair Display', serif",
            color: '#5D4037',
            mb: 1,
          }}
        >
          {t('testimonials_headline')}
        </Typography>
        <Typography
          variant="subtitle1"
          sx={{ color: '#795548', maxWidth: '600px', mx: 'auto' }}
        >
          {t('testimonials_subheadline')}
        </Typography>
      </Box>

      <Swiper
        modules={[Pagination, Autoplay]}
        spaceBetween={30}
        slidesPerView={slidesPerView}
        pagination={{ clickable: true }}
        loop={true}
        autoplay={{
          delay: 5000,
          disableOnInteraction: false,
        }}
        style={{ paddingBottom: '50px' }}
      >
        {testimonialsData.map((testimonial, index) => (
          <SwiperSlide key={index}>
            <Card
              sx={{
                height: '100%',
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'space-between',
                borderRadius: '16px',
                p: 3,
                backgroundColor: 'rgba(255, 253, 250, 0.9)',
                boxShadow: '0 8px 32px 0 rgba(139, 69, 19, 0.1)',
                backdropFilter: 'blur(4px)',
                border: '1px solid rgba(255, 255, 255, 0.18)',
              }}
            >
              <CardContent sx={{ p: 0, flexGrow: 1 }}>
                <FormatQuoteIcon sx={{ fontSize: 60, color: '#A1887F', mb: 1 }} />
                <Typography variant="body1" sx={{ fontStyle: 'italic', mb: 2, color: '#5D4037' }}>
                  "{t(testimonial.quoteKey)}"
                </Typography>
              </CardContent>
              <Box sx={{ mt: 'auto' }}>
                <Rating name="read-only" value={testimonial.rating} readOnly />
                <Box sx={{ display: 'flex', alignItems: 'center', mt: 2 }}>
                  <Avatar sx={{ bgcolor: '#A1887F', mr: 2 }} />
                  <Box>
                    <Typography variant="body1" sx={{ fontWeight: 'bold', color: '#3E2723' }}>
                      {t(testimonial.nameKey)}
                    </Typography>
                    <Typography variant="body2" sx={{ color: '#795548' }}>
                      {t(testimonial.originKey)}
                    </Typography>
                  </Box>
                </Box>
              </Box>
            </Card>
          </SwiperSlide>
        ))}
      </Swiper>
    </Box>
  );
};

export default Testimonials;